import { gql } from '@apollo/client';

export const SUBMIT_ASSIGNMENT_SIMPLE_DRAFT = gql`
  mutation SubmitAssignmentSimpleDraft($file: ArtworkUpload!) {
    submitAssignmentSimple(artwork: $file) {
      submissionId
      submissionStatus
      reviewFlowEnabled
      resubmittedAt
      latestReviewPublishedAt
      artworks {
        artworkId
        medias {
          mediaId
          url
          priority
        }
      }
    }
  }
`;

export const DELETE_ASSIGNMENT_MEDIA_DRAFT = gql`
  mutation DeleteAssignmentMediaSimpleDraft(
    $assignmentId: String!
    $mediaId: String!
    $draftMode: Boolean!
  ) {
    deleteAssignmentMediaSimple(
      assignmentId: $assignmentId
      mediaId: $mediaId
      draftMode: $draftMode
    ) {
      submissionId
      submissionStatus
      reviewFlowEnabled
      artworks {
        artworkId
        medias {
          mediaId
          url
          priority
        }
      }
    }
  }
`;
